<template>
  <div>
    <small> {{ questionLength }} / {{ limit }}</small>
    <div v-for="(question,key) in questions"
         :key="key"

         class="mb-3"
         :prepend="'Question '+ (key+1) "
    >
      <label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
      <span class="text-gray-500 sm:text-sm text-blue-500 font-bold">
        {{ text + (key + 1) }}
      </span>
          </div>
          <input :value="question.subject" type="text" name="price" id="price"
                 :class="{'pl-24': pl==='lg','pl-10': pl==='md'}"
                 class="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                 @change="changeQuestion(question,$event)" @keyup="">
          <div class="absolute inset-y-0 right-0 flex items-center">
            <button @click="removeQuestion(question)" :disabled="questionLength === 1"
                    class="inline-flex items-center px-4 py-2 bg-transparent border border-transparent  font-semibold text-md text-red-300 uppercase tracking-widest  focus:outline-none hover:text-red-500 focus:shadow-outline-red disabled:opacity-25 transition">
              &cross;
            </button>
          </div>
        </div>

      </label>


    </div>

    <div class="flex justify-end">

      <button type="button" v-if='questionLength < limit' @click="addQuestion()"
              class="focus:outline-none rounded-full bg-white hover:bg-blue-100 text-blue-500 border-2  mt-2 py-1 px-2  border-blue-500 font-bold rounded">
        Add
      </button>
      <button type="button" @click="resetQuestion()"
              class="focus:outline-none rounded-full bg-white hover:bg-gray-100 text-gray-500 border-2  mt-2 py-1 px-2 ml-2 border-gray-500 font-bold rounded">
        Reset
      </button>

    </div>
  </div>
</template>

<script>

import Input from "@/Jetstream/Input";

export default {
  props: {
    pl: {
      type: String,
      required: false,
      default: 'lg'
    },
    text: {
      type: String,
      required: false,
      default: 'Question '
    },
    questions: {
      type: Array,
      required: true,
      default: []
    },
    limit: {
      type: Number,
      required: false,
      default: 10
    },
  },
  components: {
    Input
  },
  data() {
    return {
      resetQuestions: [],
    }
  },
  computed: {
    questionLength() {
      return this.questions.length;
    }
  },
  methods: {
    changeQuestion(question, value) {
      question.subject = value.target.value;
    },
    sortQuestions() {
      this.questions.sort((x, y) => x.sort - y.sort);
    },
    addQuestion() {
      let len = this.questions.length;
      if (len < this.limit) {
        this.questions.push(
            {
              sort: len + 1,
              subject: ''
            }
        )
      }
    },
    removeQuestion(question) {
      let index = this.questions.indexOf(question);
      this.questions.splice(index, 1);
    },
    resetQuestion() {
      while (this.questions.length) {
        this.questions.pop();
      }
      this.resetQuestions.forEach((v) => this.questions.push(v));
    }
  },
  created() {
  },
  mounted() {
    this.sortQuestions();
    this.resetQuestions = [...this.questions];
  }
}
</script>

<style scoped>


</style>
